import { Stack, Typography } from '@mui/material';

const fontFamily = 'Inter';

const ProductPreviewV3 = ({
  textColor,
  name,
  quantity,
  imageUrl
}: {
  textColor: string;
  name: string;
  quantity: string;
  imageUrl: string;
}) => {
  return (
    <Stack
      direction="column"
      height={'48px'}
      width={'100%'}
      px={'12px'}
      py={'8px'}
    >
      <Stack direction="row" gap={1.5} justifyContent="space-between">
        <Stack direction="row" gap={1.5} alignItems="center" display="flex">
          <img
            src={imageUrl}
            alt={name}
            style={{
              width: '40px',
              height: '40px'
            }}
          />
          <span
            style={{
              fontSize: '14px',
              fontWeight: 200,
              fontFamily: fontFamily,
              color: textColor
            }}
          >
            {name}
          </span>
        </Stack>
        <Typography
          fontSize={'14px'}
          fontWeight={200}
          color={textColor}
          display="flex"
          alignItems="center"
          fontFamily={fontFamily}
        >
          {quantity}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default ProductPreviewV3;
